import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import PromptLibrary from './components/pages/prompt-library/PromptLibrary';
import Documentation from './components/pages/documentation/Documentation';
import Training from './components/pages/training/Training';
import Landing from './components/pages/landing/Landing';
import NotFound from './components/pages/not-found/NotFound';
import PrivacyPolicy from './components/pages/privacy-policy/PrivacyPolicy';

const App = () => {
  return (
    <Router>
      <>
        <Routes>
          <Route path="/" element={ <Landing /> } />
          <Route path="/prompt-library" element={ <PromptLibrary /> } />
          <Route path="/documentation" element={ <Documentation /> } />
          <Route path="/training" element={ <Training />} />
          <Route path="/privacy-policy" element={ <PrivacyPolicy />} />
          <Route path="*" element={ <NotFound /> } />
        </Routes>
      </>
    </Router>
  );
}

export default App;
